export default {
    delete_scheduled_action_title: "Borrar acción programada",
    delete_scheduled_actions_title: "Borrar acciones programadas",
    delete_scheduled_action_message: "¿Está seguro de que desea eliminar la acción programada?",
    delete_scheduled_actions_message: "¿Está seguro de que desea eliminar las acciones programadas?",
    delete_scheduled_action_success_message: "Se ha eliminado la acción programada",
    delete_scheduled_actions_success_message: "Se han eliminado las acciones programadas",
    delete_scheduled_action_error_message: "No es posible eliminar la acción programada",
    delete_scheduled_actions_error_message: "No es posible eliminar las acciones programadas",
}